import { IconLogo } from 'src/components/Svg/Images';
import { Separator } from '@/components/ui/separator';
import { AppProductTypeEnum } from 'src/graphql/schema';
import { productTypeMap } from 'src/shared/mappings/productTypeMap';

const PROTECTIONS = [AppProductTypeEnum.SoftwareEscrow, AppProductTypeEnum.Backup, AppProductTypeEnum.CustodianProfile];

const ApplicationIllustration = () => (
  <div aria-hidden="true" className="rounded-xl bg-white p-3 shadow-sm space-y-2.5 mt-9">
    <div className="flex gap-2.5">
      <div className="flex size-7.5 shrink-0 items-center justify-center rounded-lg bg-border">
        <IconLogo className="size-4" />
      </div>
      <div className="grow space-y-1">
        <h6 className="text-sm font-bold text-foreground">One application</h6>
        <p className="text-2xs text-muted-foreground">Groups the protections below</p>
      </div>
    </div>
    <Separator />
    <ul className="space-y-2.5">
      {PROTECTIONS.map((productType) => {
        const { label, icon: Icon } = productTypeMap[productType];

        return (
          <li key={productType} className="flex items-center gap-2 text-xs font-semibold text-slate-700">
            <Icon className="size-4 shrink-0" />
            Your {label}
          </li>
        );
      })}
    </ul>
  </div>
);

export default ApplicationIllustration;
